import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getTotalRevenueReport } from "../../services/totalrevenue.services";

// Async Thunk for fetching monthly or yearly revenue report
export const fetchAnnualRevenueReport = createAsyncThunk(
  "revenueReport/fetchReport",
  async (groupBy, { rejectWithValue }) => {
    try {
      const data = await getTotalRevenueReport(groupBy);
      return data; // Returning the entire data object from the API
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const totalRevenueReportSlice  = createSlice({
  name: "totalRevenueReport",
  initialState: {
    data: null,  // Holds the revenue report data
    status: "idle",  // idle | loading | succeeded | failed
    error: null,  // Holds any error message
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnnualRevenueReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAnnualRevenueReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;  // Store the revenue data from the API
      })
      .addCase(fetchAnnualRevenueReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default totalRevenueReportSlice.reducer;
